//import Vue from 'vue';
//import Vuex from 'vuex';
import { createStore } from "vuex";
import axios from "axios";
import router from "./router";

//  Vue.use(Vuex);

//export default new Vuex.Store({
export default createStore({
  state() {
    return {
      authState: false,
      authUser: {},
      currentRoom: null,
      rooms: [],
      socket: null,
    };
  },
  getters: {
    getUserData: (state) => state.authUser,
    getRoomData: (state) => state.rooms,
    isAuthorized: (state) => state.authState,
    getSocket: (state) => state.socket,
    getCurrentRoom: (state) => state.currentRoom,
  },
  mutations: {
    ASSIGN_USER_DATA(state, payload) {
      state.authUser = payload;
    },
    ASSIGN_ROOM_DATA(state, payload) {
      state.rooms = payload;
    },
    ADD_ROOM(state, payload) {
      state.rooms = [...state.rooms, payload];
    },
    SAVE_CURRENT_ROOM(state, payload) {
      state.currentRoom = payload;
    },
    DELETE_ROOM(state, payload) {
      state.currentRoom = null;
      state.rooms = state.rooms.filter((room) => room._id !== payload._id);
    },
    TOGGLE_AUTH_STATE(state, payload) {
      state.authState = payload;
    },
    ASSIGN_SOCKET(state, payload) {
      state.socket = payload;
    },
    LEAVE_ROOM(state, payload) {
      state.currentRoom.users = payload;
    },
    REMOVE_ACCESS_ID(state, payload) {
      state.currentRoom = payload;
    },
    RESET_STATE(state) {
      state.authState = false;
      state.authUser = {};
      state.currentRoom = null;
      state.rooms = [];
    },
  },
  actions: {
    saveUserData({ commit }, payload) {
      commit("ASSIGN_USER_DATA", payload);
    },
    updateRoomData({ commit }, payload) {
      commit("ASSIGN_ROOM_DATA", payload);
    },
    addRoom({ commit }, payload) {
      commit("ADD_ROOM", payload);
    },
    deleteRoom({ commit }, payload) {
      commit("DELETE_ROOM", payload);
    },
    toggleAuthState({ commit }, payload) {
      commit("TOGGLE_AUTH_STATE", payload);
    },
    assignSocket({ commit }, payload) {
      commit("ASSIGN_SOCKET", payload);
    },
    saveCurrentRoom({ commit }, payload) {
      commit("SAVE_CURRENT_ROOM", payload);
    },
    leaveRoom({ commit }, payload) {
      commit("REMOVE_USER_ID", payload);
    },
    removeAccessId({ commit }, payload) {
      commit("REMOVE_ACCESS_ID", payload);
    },
    deleteUserAccount({ commit }) {
      const url = process.env.VUE_APP_API_URL;
      axios.delete(`${url}/api/user/current`).then(() => {
        commit("RESET_STATE");
        localStorage.clear();
        router.push({ name: "Login" });
      });
    },
  },
});
